<template>
  <div class="wap-div" :class="{'facebook-div': isFacebook().value, 'tiktok-div': isTiktok().value, 'whatsApp-div': isWhatsApp().value }">
    <!-- Please update your browser for a better browsing experience. -->
    <slot />
    <div v-if="!useIsMobile().value" class="pc-chat-div">
      <div class="chat-div" @click="storeMessageShowFn">
        <div v-if="useMessageNotReadTotal().value" class="red-dot"></div>
        <img :src="$cvWebpFn('https://image.kilimall.com/lite/new_wap/icon-shop-message.png')" />
        <div class="tip-div">Chat with Seller</div>
      </div>
      <div class="chat-div" @click="customerShowFn">
        <div v-if="useSSQunRead().value" class="red-dot"></div>
        <img :src="$cvWebpFn('https://image.kilimall.com/lite/new_wap/ic_customer_service.png')" />
        <div class="tip-div">Live Chat (Available 8:00 AM-5:00 PM)</div>
      </div>
      <div class="chat-div" @click="intelligentShowFn">
        <img :src="$cvWebpFn('https://image.kilimall.com/lite/new_wap/ic_intelligent_customer_service.png')" />
        <div>Contact Us</div>
        <div class="tip-div">Order Query (Available 24 hours)</div>
      </div>
    </div>
    <div v-if="isIntelligent" class="pc-chat-intelligent-div">
      <div class="close-btn" @click="isIntelligent = false"></div>
      <div class="bottom-div"></div>
      <iframe
        :src="`https://chat.kilimall.com/chatbot/${getChatbotKey}`"
        style="width: 100%; height: 700px; border: 0;"
        frameborder="0"
        allow="microphone"
      >
      </iframe>
    </div>

    <div
      :data-query="JSON.stringify(usePersonalCount().value)"
    ></div>
  </div>
</template>
<script setup lang="ts">
const facebookMainColor = isFacebook().value ? '#0067DF' : isTiktok().value ? '#FE2B54' : '#17AC61'
const facebookFontColor = '#000000'
const facebookFontColorA = isFacebook().value ?  '#616264' : isTiktok().value ? '#717171' : '#77787A'
const facebookFontColorB = isFacebook().value ?  '#0467DE' : isTiktok().value ? '#FE2B54' : '#15613D'
const btnColor = isFacebook().value ? '#0865FE' : isTiktok().value ? '#FE2C55' : '#1DAA61'
const btnBackgroundColor = isFacebook().value ? '#E8F1FC' : isTiktok().value ? '#FFF4F6' : '#D8FDD2'
const mainBackgroundCOlor = isFacebook().value ? '#f1f2f6' : isTiktok().value ? '#F8F8F8' : '#F4F4F4'
const voucherUrl = isFacebook().value ? 'url(https://image.kilimall.com/c/h5/imgs/ic_coupon_facebook.png)' :
  isTiktok().value ? 'url(https://image.kilimall.com/c/h5/imgs/ic_coupon_tiktok.png)' :
  'url(https://image.kilimall.com/c/h5/imgs/ic_coupon_whatsapp.png)'

const isIntelligent = ref(false)
const intelligentShowFn = () => {
  // AI客服机器人
  isIntelligent.value = true
}
const customerShowFn = () => {
  // 联系客服
  useSSQ().value.push('chatOpen')
}
const storeMessageShowFn = () => {
  // 联系卖家
  if(!useUserInfo()?.value?.accessToken) {
    const router = useRouter()
    const route = useRoute()
    router.push(`/login?redirect=${encodeURI(route.fullPath)}`)
  } else {
    usePCLiveChatPopupShow().value = true
  }
}
const getChatbotKey = computed(() => {
  const key = useCurrentCountryCode().value === 'UG' ? 'J6VQXFnqXm2zBBN2' : 'ePKrPhNkVt89XoTg'  
  return key
})
</script>

<style scoped lang="scss">

.wap-div {
  background-color: #f5f5f5;
  -webkit-font-smoothing: antialiased;
  color: #333;
  -webkit-overflow-scrolling: touch;
}
.wap-div::-webkit-scrollbar {
  display: none;
}
.facebook-div, .tiktok-div, .whatsApp-div {
  color: v-bind('facebookFontColor');
  :deep() .search-input {
    background-color: v-bind('mainBackgroundCOlor');
    border-radius: 10px;
  }
  :deep() .basic-info {
    padding-top: 30px;
    .sale-price {
      color: #000000;
    }
    .del-price {
      color: v-bind('facebookFontColorA');
    }
    .discount, .promotions-box {
      color: v-bind('facebookMainColor');
      .ship-promotion {
        color: v-bind('facebookFontColorB');
        background-color: v-bind('btnBackgroundColor');
      }
    }
  }
  :deep() .voucher-list {
    .voucher {
      color: v-bind('facebookFontColorB');
      // border-color: v-bind('facebookMainColor');
      background-image: v-bind('voucherUrl');

    }
  }
  :deep() .delivery-card .delivery-title {
    .icon {
      width: 40px;
      height: 40px;
      min-width: 40px;
    }
  }
  :deep() .delivery-card .delivery-content li {
    color: v-bind('facebookFontColorA');
    b {
      color: v-bind('facebookFontColor') !important;
    }
    span {
      color: v-bind('facebookFontColorA') !important;
      b {
        color: v-bind('facebookFontColor') !important;
      }
    }
  }
  :deep() .store-card-box .opt-bar .opt-btn {
    border-color: v-bind('facebookMainColor');
    color: v-bind('facebookMainColor');
  }
  :deep() .find-more-details, :deep() .find-more-reviews {
    border-color: v-bind('facebookMainColor');
    color: v-bind('facebookMainColor');
  }
  :deep() .basic-info .reviews-info .van-icon-star-o {
    color: v-bind('facebookFontColorA') !important;
  }
  :deep() .basic-info .reviews-info .van-icon-star {
    color: #FACF0D !important;
  }
  :deep() .review-list .van-rate .van-rate__item .van-icon-star {
    color: #FACF0D !important;
  }

  :deep() .prepaid-tips {
    color: v-bind('facebookFontColorB');
  }
  :deep() .cell-box-bl {
    border-color: #DBDDE0;
  }
  :deep() .sku-cell-box {
    border: 0;
  }
  :deep() .store-card-box {
    border: 0;
  }
  :deep() .info-card {
    border: 0;
    border-radius: 0;
    margin: 0 0 15px 0;
  }
  :deep() .product-item .product-info .product-price .price-main {
    color: v-bind('facebookFontColor');
  }
  :deep() .basic-info .small-image-box .small-image[select="1"] {
    border-color: v-bind('facebookMainColor');
  }
  :deep() .return-policy .policy-item .tips, :deep() .store-info-list .info-item .info-desc,
  :deep() .basic-info .reviews-info, :deep() .product-item .product-info .rate,
  :deep() .product-item .product-info .product-name {
    color: v-bind('facebookFontColorA');
  }
  :deep() .delivery-box {
    border-bottom: 0.5px solid #DBDDE0;
    padding-bottom: 20px;
  }
  :deep() .return-policy .policy-item {
    margin: 15px 0;
  }
  :deep() .policy-item {
    border-top: 0.5px solid #DBDDE0;
    padding: 20px 0;
  }
  :deep() .policy-item:first-child {
    padding-top: 0;
    border-top: 0;
  }
  :deep() .policy-item:last-child {
    padding-bottom: 0;
  }
  :deep() .content-wrapper{
    background-color: v-bind('mainBackgroundCOlor');
  }
  :deep() .info-card .show-all {
    color: v-bind('facebookFontColorB');
  }
  :deep() .mark-bar .mark .mark-label[select="1"] {
    border-color: v-bind('facebookMainColor');
    color: v-bind('facebookMainColor');
    text-shadow: 0 0 1px  v-bind('facebookMainColor');
    border-radius: 0;
  }
  
  :deep() .operation-bar {
    box-shadow: 0 1px 0 0 #dddfe4 inset, 0 -4px 16px 0 #0000001c;
    .van-badge--top-right {
      background: v-bind('facebookMainColor');
    }
    .opt-bar {
      overflow: inherit;
      border: 0px;
      border-radius: 0;
      margin-left: 20px;
      .add-car-btn {
        margin-right: 18px;
        background-color: #E3E4E8;
        color: #0B0D0E;
        font-size: 32px;
        border-radius: 10px;
        overflow: hidden;
      }
      .red-btn {
        background-color: v-bind('btnColor');
        font-size: 32px;
        border-radius: 10px;
        overflow: hidden;
      }
    }
  }
  :deep() .sku-wrapper {
    .goods-info .goods-inner-info .desc .price {
      color: v-bind('facebookFontColor');
    }
    .goods-info .goods-inner-info .desc .underline-price, .address-detail {
      color: v-bind('facebookFontColorA');
    }
    .address-detail .van-icon-location-o {
      color: v-bind('facebookFontColor') !important;
    }
    .specs-info-box .specs-info-item .spec-value .sku-btn[select="1"] {
      // border-color: v-bind('facebookMainColor');
      border-color: v-bind('btnBackgroundColor');
      color: v-bind('facebookFontColorB');
      border-radius: 0;
      background-color: v-bind('btnBackgroundColor');
    }

    .specs-info-box .specs-info-item .info-item-spec .size-guide {
      color: v-bind('btnColor');
    }
    .option-box .red-btn {
      background-color: v-bind('btnColor');
      font-size: 32px;
      font-weight: 700;
      border-radius: 10px;
      overflow: hidden;
    }
    .gifts-card {
      border-color: #DBDDE0;
    }
    .switch-sku-option-box {
      overflow: inherit;
      border: 0px;
      border-radius: 0;
      .add-car-btn {
        margin-right: 18px;
        background-color: #E3E4E8;
        color: #0B0D0E;
        font-size: 32px;
        border-radius: 10px;
        overflow: hidden;
      }
    }
  }
}
.tiktok-div {
  :deep() .basic-info .reviews-info .van-icon-star-o {
    color: #808080 !important;
  }
  :deep() .basic-info .reviews-info .van-icon-star-o::before {
    content: "\e727" !important;
  }
  :deep() .search-input {
    background-color: v-bind('mainBackgroundCOlor');
    border-radius: 16px;
  }
}
.whatsApp-div {
  :deep() .search-input {
    background-color: #e4e4e6;
    border-radius: 22px;
  }
  :deep() .operation-bar .opt-bar .add-car-btn, :deep() .sku-wrapper .switch-sku-option-box .add-car-btn {
    background-color: #F2F2F2;
  }
}
.pc-chat-intelligent-div {
  width: 750px;
  height:1400px;
  position: fixed;
  z-index: 99999;
  right: 40px;
  bottom: 40px;
  background: transparent;
  border-radius: 16px;
  .bottom-div {
    width: 100%;
    height: 120px;
  }
  .close-btn {
    position: absolute;
    top: 60px;
    right: 38px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 100000;
    background: #9E9E9E;
    border-radius: 100px;
    overflow: hidden;

    &:before, &:after {
      content: '';
      position: absolute;
      width: 20px;
      height: 4px;
      background-color: white;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }
    
    &:before {
      transform: translateY(-50%) rotate(45deg);
    }
    
    &:after {
      transform: translateY(-50%) rotate(-45deg);
    }
    
    &:hover:before, &:hover:after {
      background-color: #000;
    }
  }
}
.pc-chat-div {
  position: fixed;
  z-index: 99999;
  right: 0px;
  bottom: 50px;
  background: white;
  width: 112px;
  border-radius: 16px 0 0 16px;
  .chat-div {
    width: 100%;
    text-align: center;
    padding: 24px 10px;
    cursor: pointer;
    position: relative;
    .red-dot {
      position: absolute;
      top: 25px;
      right: 30px;
      width: 12px;
      height: 12px;
      background-color: #FF0000;
      border-radius: 50%;
      z-index: 10;
    }
    img {
      width: 72px;
      height: 72px;
      margin: 0 auto;
      display: block;
    }
    div {
      color: #333333;
      margin-top: 14px;
      font-size: 20px;
    }
    .tip-div {
      display: none;
      position: absolute;
      right: 140px;
      top: 48%;
      transform: translateY(-50%);
      background-color: #000000;
      color: #FFFFFF;
      padding: 12px;
      border-radius: 6px;
      font-size: 28px;
      white-space: nowrap;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      &:after {
        content: '';
        position: absolute;
        right: -7px;
        top: 30%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #000000;
      }
    }
    &:hover .tip-div {
      display: block;
    }
  }
  .chat-div:nth-child(2) {
    padding: 0 10px;
    .red-dot {
      top: 0px;
    }
  }
  .chat-div:-child {
    padding-top: 0;
    
    .tip-div {
      left: -450px;
      top: 30px;
    }
  }
}
</style>
